export const black_overlay50 = 'rgba(0, 0, 0, 0.5)';

// ボタン・アイコンボタンのホバー背景（#3310）。
// MUI が primary 由来の色で自動生成する既定のホバーと同じ濃さのグレー。
export const black_overlay4 = 'rgba(0, 0, 0, 0.04)';

export const gray5 = '#F6F7F8';

export const gray10 = '#F9F9F9';

export const gray20 = '#F3F3F3';

export const gray30 = '#E2E8F0';

export const gray35 = '#D9D9D9';

export const gray40 = '#DBDBDB';

export const gray60 = '#B3B3B3';

export const gray80 = '#757575';

export const gray90 = '#45556C';

export const gray100 = '#000000';

export const gray110 = '#0A0A0A';

export const grayBlue50 = '#717182';

export const grayBlue40 = '#45556C';

export const grayBlue30 = '#A4B1B9';

export const grayBlue20 = '#90A1B9';

export const navy50 = '#171B4B';

export const navy100 = '#0D1030';

export const white = '#FFFFFF';

export const white_overlay30 = 'rgba(255, 255, 255, 0.3)';

export const white_overlay80 = 'rgba(255, 255, 255, 0.8)';

export const orange60 = '#F75E17';

export const orange50 = '#F03C0A';

export const orange40 = '#D63408';

export const orange30 = '#F3633B';

export const orange20 = '#FBC4B5';

export const orange10 = '#FEE2D5';

export const orange_overlay30 = 'rgba(240, 60, 10, 0.3)';

export const orange_overlay20 = 'rgba(240, 60, 10, 0.2)';

export const red90 = '#760311';

export const red50 = '#BD0017';

export const red20 = '#FFEBEB';

export const blue90 = '#0C6394';

export const blue60 = '#2B7FFF';

export const blue50 = '#0A7EBF';

export const blue20 = '#EBFAFF';

export const green50 = '#00A33C';

export const green20 = '#E6F4EA';

export const yellow50 = '#CA8A04';

export const yellow_overlay10 = 'rgba(202, 138, 4, 0.1)';

// API ドキュメント・APIキー表示UI 用
export const apiDocCodeBg = '#0F1115';
export const apiDocCodeText = '#E8EEF5';
export const apiKeyBoxBg = '#F5F5F5';

export const primaryButtonBackgroundColor = {
  '&:disabled': {
    backgroundColor: orange20,
    color: white,
  },
  '&:hover': {
    backgroundColor: orange30,
    boxShadow: 'none',
    color: white,
  },
  backgroundColor: orange50,
  boxShadow: 'none',
  color: white,
};

export const secondaryButtonBackgroundColor = {
  '&:disabled': {
    backgroundColor: white,
    border: `1px solid ${orange20}`,
    color: orange20,
  },
  '&:hover': {
    backgroundColor: white,
    border: `1px solid ${orange30}`,
    boxShadow: 'none',
    color: orange30,
    opacity: '80%',
  },
  backgroundColor: white,
  border: `1px solid ${orange50}`,
  boxShadow: 'none',
  color: orange50,
};

export const tertiaryButtonBackgroundColor = {
  '&:disabled': {
    backgroundColor: white,
    border: `1px solid ${gray40}`,
    color: gray40,
  },
  '&:hover': {
    backgroundColor: white,
    border: `1px solid ${gray60}`,
    boxShadow: 'none',
    color: gray60,
    opacity: '80%',
  },
  backgroundColor: white,
  border: `1px solid ${gray80}`,
  boxShadow: 'none',
  color: gray80,
};

export const tertiaryButtonBackgroundColorWhiteOverlay80 = {
  '&:disabled': {
    backgroundColor: white_overlay80,
    border: `none`,
    color: gray40,
  },
  '&:hover': {
    border: `none`,
    boxShadow: 'none',
    color: gray60,
    opacity: '80%',
  },
  border: `none`,
  boxShadow: 'none',
  color: gray80,
};

export const buttonTextIconLarge = {
  fontSize: '16px',
  fontWeight: 700,
};

export const linkColor = {
  '&:hover': {
    color: '#0A7EBF',
    textDecorationColor: '#0A7EBF',
  },
  color: gray100,
  fontSize: '12px',
  textDecorationColor: gray100,
};
